import { Mail, MapPin, Phone, UserRound } from "lucide-react";

export default function OrderContact({ order }) {
  const u = order.customer || {};
  const d = order.delivery_address || {};
  const name = d.name || u.name;
  const email = order.customer_email || d.email || u.email;
  const phone = d.phone || u.phone;
  const addr = d.line1
    ? [d.line1, d.line2, `${d.postal_code || ""} ${d.city || ""}`.trim(), d.country && d.country !== "FR" ? d.country : ""]
    : [u.address_line, `${u.postal_code || ""} ${u.city || ""}`.trim()];
  const address = addr.filter(Boolean).join(", ");
  if (!name && !email && !phone && !address) return null;
  const row = "flex items-start gap-1.5";
  return (
    <li data-testid={`order-contact-${order.session_id}`} className="rounded-lg bg-cream px-3 py-2 text-xs text-bark">
      <span className="mb-1 block font-semibold">Coordonnées du client{order.payment_method === "cheque" && " · paiement par chèque"}{!order.customer_id && " · sans compte"}</span>
      <span className="grid gap-1 sm:grid-cols-2">
        {name && <span className={row}><UserRound size={12} className="mt-0.5 shrink-0 text-amber-deep" />{name}</span>}
        {email && <a href={`mailto:${email}`} data-testid={`order-contact-email-${order.session_id}`} className={`${row} break-all hover:text-amber-deep`}><Mail size={12} className="mt-0.5 shrink-0 text-amber-deep" />{email}</a>}
        {phone && <a href={`tel:${phone}`} data-testid={`order-contact-phone-${order.session_id}`} className={`${row} hover:text-amber-deep`}><Phone size={12} className="mt-0.5 shrink-0 text-amber-deep" />{phone}</a>}
        {address && <span className={row}><MapPin size={12} className="mt-0.5 shrink-0 text-amber-deep" />{address}</span>}
      </span>
    </li>
  );
}
